import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import LivePage from "../Pages/liveSlot/LivePage";
import ProfilePage from "../Pages/ProfilePage";
import RedirectClient from "../Pages/redirectPath/Redirect";
import AddConfiguration from "../Pages/addConfiguration/AddConfiguration";
import LoginForm from "../Pages/LoginForm";
import { ROUTES } from "../constants/routes";
import { PrivateRoute } from "../components/privateRoute";

const TrackRedirect = () => {
  React.useEffect(() => {
    window.location.replace("https://bit.ly/track-ride");
  }, []);
  return null;
};

const AppRouters = () => {
  return (
    <Routes>

      {/* FIRST PAGE → LOGIN */}
      <Route path="/" element={<LoginForm />} />

      {/* REDIRECT PAGE (NO LAYOUT) */}
      <Route path={ROUTES.REDIRECT_PAGE} element={<RedirectClient />} />
      <Route path={ROUTES.TRACK_PAGE} element={<TrackRedirect />} />

      {/* PROTECTED PAGES WITH LAYOUT */}
      <Route element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        <Route path={ROUTES.LIVE} element={<LivePage />} />
        <Route path={ROUTES.PROFILE_PAGE} element={<ProfilePage />} />
        <Route path={ROUTES.ADD_CONFIGURATION} element={<AddConfiguration />} />
      </Route>

      {/* ANY UNKNOWN PATH → LOGIN */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRouters;
